export default {
  name: 'home',
  path: '/',
  component: () => import('@/views/home'),
  children: [
    {
      name: 'index', // 首页
      path: '',
      component: () => import('@/views/home/new-entry')
    },
    {
      name: 'tender', // 招标公告
      path: 'tender',
      component: () => import('@/views/home/tender')
    },
    {
      name: 'tender-detail', // 招标详情
      path: 'tender/:id',
      component: () => import('@/views/home/tender/detail')
    },
    {
      name: 'winTender', // 中标公告
      path: 'winTender',
      component: () => import('@/views/home/winTender')
    },
    {
      name: 'winTender-detail', // 中标详情
      path: 'winTender/:id',
      component: () => import('@/views/home/winTender/detail')
    }
    // {
    //   name: 'new-index', // 首页
    //   path: 'newIndex',
    //   component: () => import('@/views/home/new-entry')
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/home.js